import request from '@/utils/request.js';
// 获取累计签到次数
export const getSignTimes = params =>
  request({ url: '/v1/activity/act_sign_times', method: 'get', params });
// 签到活动获取可领取礼包和推荐礼包
export const getGiftList = params =>
  request({ url: '/v1/activity/gift_list', method: 'get', params });
// 签到活动获取奖品列表
export const geRewardList = params =>
  request({ url: '/v1/activity/reward_list', method: 'get', params });
// 签到活动用户签到
export const userSignIn = data =>
  request({ url: '/v1/activity/act_sign_in', method: 'post', data });
// 签到活动用户领取礼包
export const signPickGift = data => request({ url: '/v1/activity/get_gift', method: 'post', data });
// 礼包活动抽奖结果奖品信息
export const getLotteryResultInfo = data =>
  request({ url: '/v1/activity/luck_draw', method: 'post', data });
// 获取最后一次保存的收货地址
export const getAddressInfo = () => request({ url: '/v1/address/last_info', method: 'get' });
// 添加收货地址
export const addAddressInfo = data => request({ url: '/v1/address/save', method: 'post', data });
// 获取抽奖记录列表
export const getLotteryRecordList = params =>
  request({ url: '/v1/activity/luck_draw_record', method: 'get', params });
// 用户持有代金券
export const voucherHaveList = () => request({ url: '/v1/cash_coupon/have', method: 'get' });
// 用户已使用代金券
export const voucherRecordList = () => request({ url: '/v1/cash_coupon/used', method: 'get' });
// 用户已失效代金券
export const voucherInvalidList = () => request({ url: '/v1/cash_coupon/invalid', method: 'get' });
// 秒杀活动埋点上报
export const seckillPointReport = data =>
  request({ url: '/v1/data/report', method: 'post', data, isAct: true });
// 秒杀活动绑定游戏账号
export const seckillBindAccount = data =>
  request({ url: '/v1/user/bind', method: 'post', data, isAct: true });
// 秒杀活动所有代金券列表
export const seckillGetVoucher = params =>
  request({ url: '/v1/act/info', method: 'get', params, isAct: true });
// 秒杀活动用户基础数据
export const seckillUserInfo = params =>
  request({ url: '/v1/user/info', method: 'get', params, isAct: true });
// 获取用户论坛绑定游戏账号
export const forumBindAccount = () =>
  request({ url: '/v1/user/forum_bind', method: 'get', isAct: true });
// 秒杀活动礼包以及推荐列表
export const seckillGiftList = params =>
  request({ url: '/v1/gift/info', method: 'get', params, isAct: true });
// 秒杀活动领取礼包
export const seckillPickGift = data =>
  request({ url: '/v1/gift/get', method: 'post', data, isAct: true });
// 秒杀活动抢夺代金券
export const seckillSnapUp = data =>
  request({ url: '/v1/act/snap_up', method: 'post', data, isAct: true });
// 秒杀活动获取jssdk签名
export const actGetSign = params =>
  request({ url: 'v1/wx/sign', method: 'get', params, isAct: true });
// 871帝王荣耀签到礼包活动 - 获取活动信息
export const signInLotteryInfo = params =>
  request({ url: '/v1/sign_in_lottery/act_info', method: 'get', params });
// 871帝王荣耀签到礼包活动 - 获取用户活动情况
export const signInLotteryUserInfo = params =>
  request({ url: '/v1/sign_in_lottery/current_info', method: 'get', params });
// 871帝王荣耀签到礼包活动 - 领取礼包
export const signInLotteryGetGift = data =>
  request({ url: '/v1/sign_in_lottery/get_gift', method: 'post', data });
// 871帝王荣耀签到礼包活动 - 抽奖
export const signInLotteryLottery = data =>
  request({ url: '/v1/sign_in_lottery/lottery', method: 'post', data });
// 871帝王荣耀签到礼包活动 - 获取抽奖结果
export const signInLotteryGetLog = params =>
  request({ url: '/v1/sign_in_lottery/get_lottery_log', method: 'get', params });
// 947逍遥三国拉收活动 - 获取活动信息
export const promoteRechargeActInfo = params =>
  request({ url: '/v1/promote_recharge/act_info', method: 'get', params });
// 947逍遥三国拉收活动 - 获取用户活动情况
export const promoteRechargeCurrentInfo = params =>
  request({ url: '/v1/promote_recharge/current_info', method: 'get', params });
// 947逍遥三国拉收活动 - 领取礼包
export const promoteRechargeGetGift = data =>
  request({ url: '/v1/promote_recharge/get_gift', method: 'post', data, showToast: true });
// 947逍遥三国拉收活动 - 签到
export const promoteRechargeSignIn = data =>
  request({ url: '/v1/promote_recharge/sign_in', method: 'post', data, showToast: true });
// 947逍遥三国拉收活动 - 领取积分
export const promoteRechargeGetScore = data =>
  request({ url: '/v1/promote_recharge/get_score', method: 'post', data, showToast: true });
// 947逍遥三国拉收活动 - 积分兑换
export const promoteRechargeScoreExchange = data =>
  request({ url: '/v1/promote_recharge/score_exchange', method: 'post', data, showToast: true });
// 947逍遥三国拉收活动 - 获取抽奖结果
export const promoteRechargeLog = params =>
  request({ url: '/v1/promote_recharge/get_exchange_log', method: 'get', params, showToast: true });
// 1001傲世龙城活动 - 获取活动信息
export const signInLotteryActInfo = params =>
  request({ url: '/v1/sign_in_lottery/act_info_second', method: 'get', params });
// 1001傲世龙城活动 - 获取用户活动情况
export const signInLotteryUserCInfo = params =>
  request({ url: '/v1/sign_in_lottery/current_info_second', method: 'get', params });
// 1001傲世龙城活动 - 签到
export const signInLotterySignIn = data =>
  request({ url: '/v1/sign_in_lottery/sign_in_second', method: 'post', data });
// 1001傲世龙城活动 - 领取签到礼包
export const signInLotteryGetGiftSecond = data =>
  request({ url: '/v1/sign_in_lottery/get_gift_second', method: 'post', data, showToast: true });
// 1001傲世龙城活动 - 领取抽奖机会
export const signInLotteryGetChance = data =>
  request({ url: '/v1/sign_in_lottery/get_lottery_chance', method: 'post', data, showToast: true });
// 1001傲世龙城活动 - 抽奖
export const signInLotteryDoLottery = data =>
  request({ url: '/v1/sign_in_lottery/lottery_second', method: 'post', data, showToast: true });
// 1001傲世龙城活动 - 获取抽奖结果
export const signInLotteryGetLogSecond = params =>
  request({ url: '/v1/sign_in_lottery/get_lottery_log_second', method: 'get', params });

// ------------ 注册抽奖活动 ------------
// 活动信息
export const signUpLotActInfo = (id) => {
  return request({ url: `/v1/rla/act_info/${id}`, method: 'get', needRlaToken: true })
}
// 用户信息
export const signUpLotUserInfo = (id) => {
  return request({ url: `/v1/rla/user_info/${id}`, method: 'get', needRlaToken: true })
}
// 用户绑定账号
export const signUpLotUserBind = (data) => {
  return request({ url: `/v1/rla/bind_game_account/${data.id}`, method: 'post', data, showToast: true })
}
// 游戏会场列表
export const signUpLotGameList = (id) => {
  return request({ url: `/v1/rla/get_game_venue_list/${id}`, method: 'get', needRlaToken: true })
}
// 游戏会场详情
export const signUpLotGameDetail = ({ id, ...params }) => {
  return request({ url: `/v1/rla/get_game_venue_info/${id}`, method: 'get', params, needRlaToken: true })
}
// 领取奖品
export const signUpLotGetGift = ({ id, ...data }) => {
  return request({ url: `/v1/rla/get_register_welfare/${id}`, method: 'post', data, needRlaToken: true })
}
// 抽奖
export const signUpLotLottery = ({ id, ...data }) => {
  return request({ url: `/v1/rla/lottery/${id}`, method: 'post', data, needRlaToken: true })
}
// 领取抽奖机会
export const signUpLotGetChance = ({ id, ...data }) => {
  return request({ url: `/v1/rla/do_task/${id}`, method: 'post', data, needRlaToken: true })
}
// 记录列表
export const signUpLotGetLog = ({ id, ...params }) => {
  return request({ url: `/v1/rla/lottery_log/${id}`, method: 'get', params, needRlaToken: true })
}

export const rlaReportData = (data) =>
  request({ url: `/v1/rla/report_data/${data.overall_id}`, method: 'post', data, needRlaToken: true })

const addLaToken = {
  _KEY: 'la_token_map',
  keyPrefix: 'laToken'
}

// 转游开红包活动
// 活动信息
export const retourGameActInfo = ({ id, ...params }) => {
  return request({ url: `/v1/lead_activity/act_info/${id}`, method: 'get', params, addToken: addLaToken })
}
// 会场信息
export const retourGameExpoInfo = ({ id, ...params }) => {
  return request({ url: `/v1/lead_activity/expo_info/${id}`, method: 'get', params, addToken: addLaToken })
}
// 奖励介绍接口
export const retourGameRewardInfo = ({ id, ...params }) => {
  return request({ url: `/v1/lead_activity/packet_voucher_list/${id}`, method: 'get', params, addToken: addLaToken, showToast: true  })
}
// 领取创角礼包接口
export const retourGameGetRoleGift = (data) =>
  request({ url: `/v1/lead_activity/role_gift_receive/${data.id}`, method: 'post', data, addToken: addLaToken, showToast: true  })
// 领取创角礼包接口
export const retourGameGetReward = (data) =>
  request({ url: `/v1/lead_activity/condition_receive/${data.id}`, method: 'post', data, addToken: addLaToken, showToast: true  })
// 开红包接口
export const retourGameGetRedBag = (data) =>
  request({ url: `/v1/lead_activity/packet_voucher_receive/${data.id}`, method: 'post', data, addToken: addLaToken, showToast: true  })
// 用户领取记录接口
export const retourGameRecordList = ({ id, ...params }) => {
  return request({ url: `/v1/lead_activity/receive_record_list/${id}`, method: 'get', params, addToken: addLaToken, showToast: true  })
}
// 用户红包记录接口
export const retourGameVoucherList = ({ id, ...params }) => {
  return request({ url: `/v1/lead_activity/user_voucher_list/${id}`, method: 'get', params, addToken: addLaToken, showToast: true  })
}
// 埋点接口
export const retourGameReport = (data) =>
  request({ url: `/v1/lead_activity/report_data/${data.id}`, method: 'post', data, addToken: addLaToken })

// 保存微信一次性订阅结果
export const retourGameSaveWechatOnceSubscribeRecord = (act_id, data) =>
  request({ url: `/v1/lead_activity/save_wechat_once_subscribe_record/${act_id}`, method: 'post', data, addToken: addLaToken })

